/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, December 2020
 * @format
 * @flow
 */

import React from 'react';
import { Box } from '@material-ui/core';
import Whiteboard from './Whiteboard';
import LeftSection from '../LeftSection';
import ConfirmationPopup from '../ConfirmationPopup';

const Body = (props) => {
  const {
    selectedShape,
    onChangeShape,
    selectShape,
    onStageClicked,
    shapes,
    popup,
  } = props;
  return (
    <Box display={'flex'}>
      <Box width={'30%'} position={'relative'}>
        <LeftSection {...props} />
        {(!!popup && popup?.type === 'confirmation') && (
          <ConfirmationPopup {...popup} />
        )}
      </Box>
      <Box width={'70%'}>
        <Whiteboard
          onChangeShape={onChangeShape}
          selectShape={selectShape}
          onStageClicked={onStageClicked}
          draggable={true}
          shapes={shapes}
          selectedShape={selectedShape}
        />
      </Box>
    </Box>
  );
};

export default Body;
